// 待支付
const ORDER_WAIT_PAY = 100;
// 已取消（未支付）
const ORDER_WAIT_PAY_CANCELED = 110;
// 取消中（已支付）
const ORDER_WAIT_PAY_CANCEL = 120;
// 待发货（未截团）
const ORDER_WAIT_SEND = 200;
// 已取消（待退款）
const ORDER_WAIT_REFUND = 201;
// 已取消（待发货）
const ORDER_WAIT_SEND_CANCELED = 210;
// 待收货（已截团）
const ORDER_WAIT_RECEIVE = 300;
// 已确认收货
const ORDER_SUCCESS = 400;
// 已完结
const ORDER_COMPLETE = 500;
const OrderStatus = {
    ORDER_WAIT_PAY,
    ORDER_WAIT_PAY_CANCELED,
    ORDER_WAIT_PAY_CANCEL,
    ORDER_WAIT_SEND,
    ORDER_WAIT_REFUND,
    ORDER_WAIT_SEND_CANCELED,
    ORDER_WAIT_RECEIVE,
    ORDER_SUCCESS,
    ORDER_COMPLETE,
};
OrderStatus['ALL'] = [
    ORDER_WAIT_PAY,
    ORDER_WAIT_PAY_CANCELED,
    ORDER_WAIT_PAY_CANCEL,
    ORDER_WAIT_SEND,
    ORDER_WAIT_REFUND,
    ORDER_WAIT_SEND_CANCELED,
    ORDER_WAIT_RECEIVE,
    ORDER_SUCCESS,
    ORDER_COMPLETE,
];

export default OrderStatus;